import React, { useEffect, useState } from 'react';
import { Box, HStack, Text, VStack } from '@chakra-ui/react';
import { MessageCircle } from 'lucide-react';
interface Activity {
  name: string;
  city: string;
  state: string;
  id: number;
}
const names = ['María González', 'Carlos Rodríguez', 'Ana Martínez', 'José López', 'Carmen Hernández', 'Miguel Pérez', 'Rosa Sánchez', 'Juan Ramírez', 'Isabel Torres', 'Francisco García', 'Elena Flores', 'Roberto Morales', 'Sofía Reyes', 'Diego Jiménez', 'Patricia Ruiz'];
const cities = [{
  city: 'Miami',
  state: 'FL'
}, {
  city: 'Los Angeles',
  state: 'CA'
}, {
  city: 'Houston',
  state: 'TX'
}, {
  city: 'New York',
  state: 'NY'
}, {
  city: 'Chicago',
  state: 'IL'
}, {
  city: 'Phoenix',
  state: 'AZ'
}, {
  city: 'San Antonio',
  state: 'TX'
}, {
  city: 'Dallas',
  state: 'TX'
}, {
  city: 'San Diego',
  state: 'CA'
}, {
  city: 'Las Vegas',
  state: 'NV'
}, {
  city: 'Orlando',
  state: 'FL'
}, {
  city: 'Atlanta',
  state: 'GA'
}, {
  city: 'Denver',
  state: 'CO'
}, {
  city: 'Boston',
  state: 'MA'
}, {
  city: 'Seattle',
  state: 'WA'
}];
export function LiveActivityCounter() {
  const [currentActivity, setCurrentActivity] = useState<Activity | null>(null);
  useEffect(() => {
    const interval = setInterval(() => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const newActivity: Activity = {
        name: randomName,
        city: randomCity.city,
        state: randomCity.state,
        id: Date.now()
      };
      setCurrentActivity(newActivity);
      // Hide notification after 5 seconds
      setTimeout(() => {
        setCurrentActivity(null);
      }, 5000);
    }, 15000); // New activity every 15 seconds
    return () => clearInterval(interval);
  }, []);
  return <>
      {/* Floating notification */}
      {currentActivity && <Box position="fixed" bottom={{
      base: 4,
      md: 6
    }} left={{
      base: 4,
      md: 6
    }} zIndex={1000} animation="slideInLeft 0.5s ease-out" sx={{
      '@keyframes slideInLeft': {
        from: {
          transform: 'translateX(-100%)',
          opacity: 0
        },
        to: {
          transform: 'translateX(0)',
          opacity: 1
        }
      }
    }} data-id="element-5">
          <Box bg="rgba(0, 0, 0, 0.95)" borderWidth="2px" borderColor="brand.500" borderRadius="lg" p={4} maxW={{
        base: '280px',
        md: '320px'
      }} boxShadow="0 0 30px rgba(220, 38, 38, 0.5)" backdropFilter="blur(10px)" data-id="element-6">
            <HStack spacing={3} data-id="element-7">
              <Box bg="brand.500" borderRadius="full" p={2} display="flex" alignItems="center" justifyContent="center" data-id="element-8">
                <MessageCircle size={18} color="white" data-id="element-9" />
              </Box>
              <VStack align="start" spacing={0} flex={1} data-id="element-10">
                <Text fontSize="sm" color="white" fontWeight="bold" data-id="element-11">
                  {currentActivity.name}
                </Text>
                <Text fontSize="xs" color="gray.400" data-id="element-12">
                  {currentActivity.city}, {currentActivity.state}
                </Text>
                <Text fontSize="xs" color="fire.400" fontWeight="medium" mt={1} data-id="element-13">
                  Acaba de contactar por WhatsApp
                </Text>
              </VStack>
            </HStack>
          </Box>
        </Box>}
    </>;
}